"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.default = styled_components_1.default.p `
  color: ${config_1.colors.white};
  font: ${config_1.fontWeights.regular} ${config_1.fontSizes.medium} ${config_1.fontFamilies.primary};
  max-width: 380px;
  text-align: center;

  @media ${config_1.device.laptopLarge} {
    max-width: 600px;
  }
`;
